import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";
import RegularButton from "../../../components/Buttons/RegularButton";
import {
  addHoursToDate,
  dateRange,
  formatIndianDateTime,
  roundNumber,
} from "../../../redux/services/utility";
import {
  getSpecificEnumData,
  setEnumData,
} from "../../../redux/slices/enumSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { useGetEnumDataMutation } from "../../../redux/services/enumApi";
import { getUserData } from "../../../redux/slices/authSlice";
import {
  useDeleteCartDetailItemMutation,
  useFindByCartIdMutation,
  useSaveCartDetailMutation,
} from "../../../redux/services/cartApi";
import {
  useCalculateBillingRateMutation,
  useSaveAuditLogMutation,
} from "../../../redux/services/calculateBillingRateService";
import format from "date-fns/format";
import { useSelector } from "react-redux";
import MuiAlert from "../../MuiAlert/MuiAlert";
import "pure-react-carousel/dist/react-carousel.es.css";
import { MdLocalGasStation, MdOutlineRoomService, MdTimeline } from "react-icons/md";
import { useFindServiceProviderDetailByParkingIdMutation } from "../../../redux/services/serviceProviderFeedbackApi";
import {
  getServiceProviderFeedbackData,
  setServiceProviderFeedback,
} from "../../../redux/slices/serviceProviderFeedbackSlice";
import {
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Checkbox,
  Typography,
  Button,
  Modal,
  Box,
  Tooltip,
  IconButton,
  FormHelperText,
  Stack,
  Rating,

} from "@mui/material";
import { Plus, Pencil, Trash } from "lucide-react";

import { selectCustomerData } from "../../../redux/slices/customerSlice";
import { MdCancel } from "react-icons/md";
import { getCartData, setCart } from "../../../redux/slices/cartSlice";
import Loading from "../../commons/Loading";
import { useSaveCustomerFavouriteMutation } from "../../../redux/services/favouriteApi";
import {
  getFavouriteData,
  setFavouriteDetail,
} from "../../../redux/slices/favouriteSlice";
import { FaTimesCircle } from "react-icons/fa";
import {
  useFindParkingSpaceLocationByIdMutation,
  useGetAllParkingSpaceLoByLatAndLangMutation,
} from "../../../redux/services/parkingsApi";
import {
  getParkingSpaces,
  getSelectedParkingBlackout,
  getSelectedParkingSpace,
  getVehicleCategory,
  setSelectedParking,
} from "../../../redux/slices/parkingSlice";
import {
  getFromLocation,
  getIsLoggedInData,
  getLocation,
  getSubCategoryData,
  getTimeZone,
  getToLocation,
  getTypeName,
  setFromLocation,
  setToLocation,
  resetNav,
  getTripDetails,
  getBookingDetails,
} from "../../../redux/slices/navSlice";
import { timezones } from "../../Home/timezones";
import { getVehicleData, setVehicle } from "../../../redux/slices/vehicleSlice";
import { useSearchCustomerVehicleDetailMutation } from "../../../redux/services/VehicleApi";
import { Autocomplete } from "@react-google-maps/api";
import * as Yup from 'yup';
import { Field, Form, ErrorMessage, Formik, FormikHelpers } from "formik";
import Footer from "../../../components/Footer/Footer";
import { useGetAllCitiesMutation } from "../../../redux/services/cityApi";
import PaymentSummary from "../../../pages/Paymentsuccessful/PaymentSummary";
import LocationIcon from "../../../assets/location.png";
import GuestCounter from "../../../components/GuestCounter";
import FuelType from "../../../assets/FuelType.png";
import Cancellation from "../../../assets/Cancellation.png";
import ExtrakmFare from "../../../assets/ExtraKm.png";
import { CustomizedSteppers } from "../../../components/StatusBar/CustomStepLabel";
import clearIcon from "../../../assets/Cancel.png";

type Props = {};

const BookingDetail = (props: Props) => {
  const vehicleData = useAppSelector(getVehicleData);
  const dispatch: any = useAppDispatch();
  const parkingSpacesData = useAppSelector(getParkingSpaces);
  const getlogedIn = useAppSelector(getIsLoggedInData);
  const timeZone = useAppSelector(getTimeZone);
  const navigate = useNavigate();
  const bookingData = JSON.parse(localStorage.getItem("bookingDetails") || "{}");
  console.log(bookingData, "bookingData");
  const fromLocationData = useAppSelector(getFromLocation);
  const toLocationData = useAppSelector(getToLocation);
  const getLatLng: any = useAppSelector(getLocation);
  const userData = useSelector(getUserData);
  let enumData: any = useAppSelector(getSpecificEnumData);
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  const [actionType, setActionType] = useState("");
  const [ammenitiesList, setAmmenitiesList] = useState([]);
  const [calculateBillingRate, billingRateResponse] =
    useCalculateBillingRateMutation();
  const [saveCartDetail, addToCartResponse] = useSaveCartDetailMutation();
  const [billingDetail, setBillingDetail] = useState() as any;
  const [isLoggedIn, setIsLoggedIn] = useState() as any;
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [feedBack, setFeedBack] = useState([]);
  const [findServiceProviderDetailByUserId, userIdResponse] =
    useFindServiceProviderDetailByParkingIdMutation();
  const getFeedbackData = useAppSelector(getServiceProviderFeedbackData);
  const [findByCartId, finbByCartIdResponse] = useFindByCartIdMutation();
  let cartData: any = useAppSelector(getCartData);
  const [cartPayload, setCartPayload] = useState({});
  const [cartModel, setCartModel] = useState(false);
  const [deleteCartDetailItem, deleteCartDetailItemResponse] =
    useDeleteCartDetailItemMutation();
  const [favourite, setFavourite] = useState<any>([]);
  const [saveCustomerFavourite, favouriteResponse] =
    useSaveCustomerFavouriteMutation();
  const favouriteData = useAppSelector(getFavouriteData);
  const [findParkingSpaceLocationById, findParkingSpaceLocationByIdResponse] =
    useFindParkingSpaceLocationByIdMutation();
  const booking: any = useAppSelector(getSelectedParkingSpace);
  const blackOutDay: any = useAppSelector(getSelectedParkingBlackout);
  const customerData = useSelector(selectCustomerData) as any;
  const [isOpen, setIsOpen] = useState(false);
  const [taxOpen, setTaxOpen] = useState(false);

  const [getAllCities, { data, isLoading, error }] = useGetAllCitiesMutation();

  const getIsLoggedIn = () => {
    let isLoggedIn: any = localStorage.getItem("isLoggedIn");
    isLoggedIn = JSON.parse(isLoggedIn);
    setIsLoggedIn(isLoggedIn);
  };
  const params = useLocation() as any;
  const [auditLog, auditLogResponse] = useSaveAuditLogMutation();
  const [selectedTZOptions, setSelectedTZOptions] = useState<null | any>(
    bookingData?.selectedTZOptions
      ? bookingData?.selectedTZOptions
      : timeZone
  );
  const [parkingData, setParkingData] = useState() as any;
  const [imageData, setImageData] = useState([]);
  const id = useAppSelector(getSubCategoryData);
  const [getAllParkingSpaceLoByLatAndLang, allResponse] =
    useGetAllParkingSpaceLoByLatAndLangMutation();
  const newVehicleData = useAppSelector(getVehicleCategory);
  const [getVehicle, getVehicleResponse] =
    useSearchCustomerVehicleDetailMutation();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const customerId: any = currentUser?.customerId;
  const [cities, setCities] = useState<any[]>([]);
  const operationHoursList = bookingData?.bookingDetail?.operationHoursList;
  const placesSearchRefPickUp = useRef<HTMLInputElement>(null);
  const placesSearchRefDropOff = useRef<HTMLInputElement>(null);
  const fromCity = fromLocationData?.formatted_address;
  const fromLocationLat = fromLocationData?.lat;
  const fromLocationLng = fromLocationData?.lng;
  const toCity = toLocationData?.formatted_address;
  const toLocationLat = toLocationData?.lat;
  const toLocationLng = toLocationData?.lng;
  const getTypeNameValue = useAppSelector(getTypeName);
  const [inputFromAddress, setInputFromAddress] = useState("") as any;
  const [inputToAddress, setInputToAddress] = useState("") as any;
  const [autocompleteToCity, setAutocompleteToCity]: any = useState();
  const [autocompleteFromCity, setAutocompleteFromCity]: any = useState();
  const [searchCity, setSearchCity] = useState<string>("");
  const [storedEmail, setStoredEmail] = useState("");
  const [passengerDetails, setPassengerDetails] = useState({}) as any;
  const [storedContactNumber, setStoredContactNumber] = useState("");
  const storedPassengerDetail = JSON.parse(localStorage.getItem("passengerDetail") || "{}");
  const [adults, setAdults] = useState(1);
  const [kids, setKids] = useState(0);
  let checkInDateAddHourse = addHoursToDate(format(new Date(bookingData?.checkIn), "yyyy-MM-dd'T'HH:mm:ss.SSSX"), billingDetail?.duration || 0)
  let checkOutDateAddHourse = addHoursToDate(format(new Date(bookingData?.checkOut), "yyyy-MM-dd'T'HH:mm:ss.SSSX"), billingDetail?.duration || 0)


  useEffect(() => {
    if (searchCity) {
      getAllCities({
        token: token,
        payload: {
          offset: 5,
          page: 0,
          status: true,
          searchValue: searchCity,
        },
      }).then((response) => {
        if ("data" in response) {
          setCities(response.data.data);
        } else if ("error" in response) {
        }
      });
    }
  }, [searchCity, getAllCities]);

  const handleCalculateBilling = (pickup: string, dropOff: string, pickupAddressLat: any, pickupAddressLng: any, dropOffAddressLat: any, dropOffAddressLng: any) => {
    const payload = {
      checkInTime: format(new Date(bookingData?.checkIn), "yyyy-MM-dd HH:mm:ss"),
      checkOutTime: bookingData?.checkOut == null
        ? null
        : format(new Date(bookingData.checkOut), "yyyy-MM-dd HH:mm:ss"),
      parkingCategoryId: bookingData?.selectedParking?.selectedParkingCategoryRes?.id,
      parkingSpaceLocationId: bookingData?.bookingDetail.id,
      fromLat: pickupAddressLat,
      fromLng: pickupAddressLng,
      toLat: dropOffAddressLat,
      toLng: dropOffAddressLng,
      parkingType: bookingData.flag === "city" ? " " : getTypeNameValue,
      duration: bookingData?.tripType?.typeName === 'Hourly Rental' ? bookingData.duration : null,
      distance: bookingData?.tripType?.typeName === 'Hourly Rental' ? bookingData.distance : null,
      tollReqDTO: {
        from: {
          address: pickup,
        },
        serviceProvider: "here",
        to: {
          address: dropOff,
        },
      },
    }

    calculateBillingRate({ payload });
  };



  const clearSearchResults = (
    field: 'pickup' | 'dropoff',
    setFieldValue: (field: string, value: any) => void
  ) => {
    if (field === 'pickup' && placesSearchRefPickUp.current) {
      setInputFromAddress("");
      placesSearchRefPickUp.current.value = "";
      setFieldValue("pickupAddress", "");
      dispatch(setFromLocation(null));
      resetNav();
    }
    if (field === 'dropoff' && placesSearchRefDropOff.current) {
      setInputToAddress("");
      placesSearchRefDropOff.current.value = "";
      setFieldValue("dropOffAddress", "");
      dispatch(setToLocation(null));
      resetNav();
    }
  };

  useEffect(() => {
    if (fromLocationData?.locality) {
      setSearchCity(fromLocationData.locality);
    }
  }, [fromLocationData?.locality]);


  const city = fromLocationData?.locality || fromLocationData?.city;

  const validationSchema = Yup.object({
    pickupAddress: Yup.string()
      .required('Pickup address is required')
      .test('valid-sublocality', 'Invalid pickup location. Please select a proper location with a valid sublocality.', () => {
        return !!fromLocationData?.sublocality;
      })
      .test('city-availability', `We are currently not available in ${city}.`, () => {
        if (!city) return false;
        return cities.some((cityItem: any) => cityItem.name.toLowerCase() === city.toLowerCase());
      }),

    dropOffAddress: Yup.string().when([], {
      is: () => {
        const tripTypeName = getTypeNameValue;
        return tripTypeName !== 'Hourly Rental' && tripTypeName !== 'OutStation Round Trip';
      },
      then: (schema) =>
        schema
          .required('Dropoff address is required')
          .test(
            'valid-sublocality',
            'Invalid dropoff location. Please select a proper location with a valid sublocality.',
            () => !!toLocationData?.sublocality
          ),
      otherwise: Yup.string().notRequired(),
    }),

    //fullName: Yup.string().required("Please enter your full name"),
    //gender: Yup.string().required("Gender is required"),
    emailId: Yup.string().email("Invalid email").required("Email ID is required"),
    contactNumber: Yup.string()
      .matches(/^[0-9]{10}$/, "Enter a valid 10-digit number")
      .required("Contact number is required"),
    passengerDetails: Yup.object()
      .nullable()
      .required("At least one traveller is required")
  });

  const genderOptions = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Other", value: "Other" },
  ];

  const onSubmit = (values: any) => {
    localStorage.setItem("passengerDetail", JSON.stringify(values));
    saveBooking("BOOK", values)

  };


  useEffect(() => {
    if (parkingSpacesData) {
      const parkingById = parkingSpacesData.find((parking: any) => parking.id === bookingData?.selectedParking.id) || null;
      setParkingData(parkingById)
    }
  }, [parkingSpacesData])

  const closedDays: any = operationHoursList?.filter(
    (operationHoursList: any) => {
      return operationHoursList.operationalStatus == "closed";
    }
  );

  useEffect(() => {
    getVehicle({
      token: token,
      payload: {
        customerId: customerId,
        offset: 100,
        page: 0,
        status: true,
      },
    });
  }, []);

  useEffect(() => {
    if (getVehicleResponse.isSuccess) {
      dispatch(setVehicle(getVehicleResponse.data));
    }
  }, [getVehicleResponse.isSuccess]);

  useEffect(() => {
    if (vehicleData) {
      let categoryData: any = [];
      vehicleData &&
        vehicleData.map((obj: any) => {
          categoryData.push({
            value: obj.vehicleNumber,
            key: obj.id,
            isCommercial: obj.isCommercial,
            vehicleCategory: obj.vehicleCategory,
          });
        });

      categoryData.push({
        value: "+ Add New Vehicle",
        key: 0,
      });

      let vehicleAlreadyData = vehicleData.filter(
        (vehicle: any) => vehicle.isPrimary === true
      );
    }
  }, [vehicleData, newVehicleData]);



  const cartId: any =
    localStorage.getItem("cartId") !== "null"
      ? localStorage.getItem("cartId")
      : null;

  useEffect(() => {
    fetchParkingDetailsAsync();
  }, []);

  const fetchParkingDetailsAsync = (event?: any) => {
    const searchParams = new URLSearchParams(params.search);
    findParkingSpaceLocationById({
      id: event ? event : bookingData?.selectedParking.id,
      customerId: getlogedIn ? customerId : 0,
      token: token,
    });
    findServiceProviderDetailByUserId({
      parkingId: event ? event : bookingData?.selectedParking.id,
    });
  };

  useEffect(() => {
    if (findParkingSpaceLocationByIdResponse.isSuccess) {
      dispatch(setSelectedParking(findParkingSpaceLocationByIdResponse.data));
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [findParkingSpaceLocationByIdResponse.isSuccess]);

  useEffect(() => {
    getIsLoggedIn()
  }, []);

  const filterPassedTime = (time: any) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);
    return currentDate.getTime() < selectedDate.getTime();
  };

  useEffect(() => {
    getEnumData({ token: token });
    findServiceProviderDetailByUserId({
      parkingId: bookingData?.selectedParking.id,
    });
  }, []);


  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
  }, [enumResponse.isSuccess]);

  useEffect(() => {
    if (enumData && bookingData?.bookingDetail) {
      let data = enumData["VEHICLE_AMENITIES_TYPE"].filter(
        (item: any) =>
          bookingData?.bookingDetail &&
          bookingData?.bookingDetail?.amenitiesList &&
          bookingData?.bookingDetail.amenitiesList.some((code: any) => item.code === code)
      );
      setAmmenitiesList(data);
    }
  }, [enumData, bookingData?.bookingDetail]);

  useEffect(() => {
    if (userIdResponse.isSuccess) {
      dispatch(setServiceProviderFeedback(userIdResponse.data));
    }
  }, [userIdResponse.isSuccess]);


  useEffect(() => {
    const pickupAddress = fromLocationData && fromLocationData.sublocality ? fromLocationData.formatted_address : "";
    const dropOffAddress = toLocationData && toLocationData.sublocality ? toLocationData.formatted_address : "";
    const pickupAddressLat = fromLocationData?.lat;
    const pickupAddressLng = fromLocationData?.lng;
    const dropOffAddressLat = toLocationData?.lat;
    const dropOffAddressLng = toLocationData?.lng;
    if (pickupAddress != "" || dropOffAddress != "") {
      handleCalculateBilling(pickupAddress, dropOffAddress, pickupAddressLat, pickupAddressLng, dropOffAddressLat, dropOffAddressLng)

    }
  }, [fromLocationData, toLocationData]);

  useEffect(() => {
    if (getFeedbackData) {
      setFeedBack(getFeedbackData);
    }
  }, [getFeedbackData]);

  function buildPayload(billingDetail: any) {
    let checkInDateAddHourse = addHoursToDate(format(new Date(bookingData?.checkIn), "yyyy-MM-dd'T'HH:mm:ss.SSSX"), billingDetail?.duration || 0)
    let checkOutDateAddHourse = addHoursToDate(format(new Date(bookingData?.checkOut), "yyyy-MM-dd'T'HH:mm:ss.SSSX"), billingDetail?.duration || 0)
    const amount =
      billingDetail?.discountedAmount != null
        ? roundNumber(billingDetail?.discountedAmount)
        : roundNumber(billingDetail?.totalAmount);

    let payload: any = {
      bookingDate: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
      bookingStatus: "booked",
      checkinTime: format(new Date(bookingData?.checkIn), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
      checkoutTime:
        bookingData?.tripType?.typeName === 'Hourly Rental'
          ? format(new Date(bookingData?.checkOut), "yyyy-MM-dd'T'HH:mm:ss.SSSX")
          : bookingData?.tripType?.typeName === 'OutStation Round Trip'
            ? format(new Date(checkOutDateAddHourse), "yyyy-MM-dd'T'HH:mm:ss.SSSX")
            : format(new Date(checkInDateAddHourse), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
      paymentStatus: "pending",
      parkingCategoryId: bookingData?.selectedParking?.selectedParkingCategoryRes?.id,
      status: true,
      toLocation: toCity,
      toLatitude: toLocationLat,
      toLongitude: toLocationLng,
      fromLocation: fromCity,
      fromLatitude: fromLocationLat,
      fromLongitude: fromLocationLng,
      parkingLocationId: bookingData?.bookingDetail?.id,
      serviceProviderId: bookingData?.bookingDetail?.serviceProviderId,
      serviceType: getTypeNameValue,
      vehicleType: bookingData?.bookingDetail?.vehicleDetailObj?.type,
      parkingTypeId: bookingData?.tripType?.id,
      ammount: roundNumber(amount),
      distance: billingDetail && billingDetail?.distance,
      duration: billingDetail && billingDetail?.duration,
      discount:
        billingDetail?.discount !== null
          ? roundNumber(billingDetail?.discount)
          : 0,
      discountType: billingDetail ? billingDetail?.discountType : "",
      salesTaxRate:
        billingDetail &&
        (billingDetail?.salesTaxRate !== null
          ? roundNumber(billingDetail?.salesTaxRate)
          : 0),
      salesTaxAmount:
        billingDetail &&
        (billingDetail?.salesTaxAmount !== null
          ? roundNumber(billingDetail?.salesTaxAmount)
          : 0),
      stateTaxRate:
        billingDetail &&
        (billingDetail?.stateTaxRate !== null
          ? roundNumber(billingDetail?.stateTaxRate)
          : 0),
      stateTaxAmount:
        billingDetail &&
        (billingDetail?.stateTaxAmount !== null
          ? roundNumber(billingDetail?.stateTaxAmount)
          : 0),
      countyTaxRate:
        billingDetail &&
        (billingDetail?.countyTaxRate !== null
          ? roundNumber(billingDetail?.countyTaxRate)
          : 0),
      countyTaxAmount:
        billingDetail &&
        (billingDetail?.countyTaxAmount !== null
          ? roundNumber(billingDetail?.countyTaxAmount)
          : 0),
      totalTaxAmount:
        billingDetail &&
        (billingDetail?.totalTaxAmount !== null
          ? roundNumber(billingDetail?.totalTaxAmount)
          : 0),
      convenienceFee: billingDetail && billingDetail?.convenienceFee,
      fixedFee: billingDetail && billingDetail?.fixedFee,
      offerDetailId: billingDetail && billingDetail?.offerId,
      offerDiscount:
        billingDetail &&
        (billingDetail?.offerDiscount !== null
          ? roundNumber(billingDetail?.offerDiscount)
          : 0),
      offerType: billingDetail && billingDetail?.offerType,
      totalAmount:
        billingDetail &&
        (billingDetail?.totalAmount !== null
          ? roundNumber(billingDetail?.totalAmount)
          : 0),
      parkingSpaceName: bookingData?.bookingDetail.name,
      booking: true,
      channel: "WEB",
      userTimezone: selectedTZOptions && selectedTZOptions[0].value,
      tollCharges: billingDetail && billingDetail?.tollCharges,
      finalAmount:
        billingDetail?.discountedAmount != null
          ? roundNumber(billingDetail?.discountedAmount)
          : roundNumber(billingDetail?.totalAmount) + billingDetail &&
          billingDetail?.convenienceFee + billingDetail &&
          (billingDetail?.totalTaxAmount !== null
            ? roundNumber(billingDetail?.totalTaxAmount)
            : 0),
    };

    payload["finalAmount"] =
      amount + payload["convenienceFee"] + payload["totalTaxAmount"];
    payload["totalBookingAmount"] =
      amount + payload["convenienceFee"] + payload["totalTaxAmount"];
    payload["taxAmount"] = payload["totalTaxAmount"];
    payload["redeemAmount"] = 0;
    if (isLoggedIn) {
      payload["customerId"] = customerId;
    }
    return payload;
  }

  const routeToPayment = (payload: any) => {
    localStorage.setItem("partialPayment", JSON.stringify({ partialPayment: false, partialPaidAmount: 100, }));
    localStorage.setItem("bookingDetail", JSON.stringify(payload));
    navigate("/profile/payment", {
      state: {
        bookingDetail: payload,
        parkingDetail: bookingData?.bookingDetail,
      },
    });
  };



  const saveBooking = (type: string, value: any) => {
    setActionType(type);
    const payload = buildPayload(billingDetail);
    addToCart(payload, value);
  };

  function addToCart(payload: any, value: any) {
    let cartPayload: any = {
      bookingDetail: { payload, tripDetails: value },
      parkingDetail: bookingData?.bookingDetail,
      customerId: isLoggedIn ? customerId : null,
      status: true,
    };
    if (localStorage.getItem("cartId") !== "null") {
      cartPayload["cartId"] = localStorage.getItem("cartId");
    }
    if (localStorage.getItem("id") !== "null") {
      cartPayload["id"] = localStorage.getItem("id");
    }
    saveCartDetail({
      token: token,
      payload: cartPayload,
    });
    auditLog({
      payload: {
        cartId: cartId,
        endTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
        eventName: "WEB",
        request: JSON.stringify(cartPayload),
        response: "{}",
        serviceName: "ADD_CART_START",
        startTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
        url: "/api/cartDetail/save",
      },
    });
    setCartPayload(cartPayload);
  }



  useEffect(() => {
    if (billingRateResponse.isSuccess) {
      setBillingDetail(billingRateResponse.data);

    }
    if (billingRateResponse.isError) {
      let errorData: any = billingRateResponse.error;
      setStatusCode({ type: "error", code: "NOT_GOT_BILLING_RATE" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [billingRateResponse.isSuccess, billingRateResponse.isError]);

  useEffect(() => {
    if (addToCartResponse.isSuccess) {
      localStorage.setItem(
        "cartId",
        JSON.stringify(addToCartResponse.data?.cartId)
      );
      localStorage.setItem("id",
        JSON.stringify(addToCartResponse.data?.id))
      findByCartId({
        id: localStorage.getItem("cartId"),
      });
      const currentDate = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX");
      auditLog({
        payload: {
          cartId: cartId,
          endTime: currentDate,
          eventName: "WEB",
          request: JSON.stringify(cartPayload),
          response: JSON.stringify(addToCartResponse),
          serviceName: "ADD_CART_START",
          startTime: currentDate,
          url: "/api/cartDetail/save",
        },
      });
    }
  }, [addToCartResponse.isSuccess]);

  useEffect(() => {
    if (
      localStorage.getItem("cartId") != "null" &&
      localStorage.getItem("cartId") != null
    ) {
      findByCartId({
        id: localStorage.getItem("cartId"),
      });
    }
  }, []);

  useEffect(() => {
    if (finbByCartIdResponse.isSuccess) {
      dispatch(setCart(finbByCartIdResponse.data));
      if (actionType === "BOOK") {
        const payload = buildPayload(billingDetail);
        routeToPayment(payload);
      }
    }
  }, [finbByCartIdResponse.isSuccess]);

  const deleteAndAddCart = (cartID: any) => {
    let payload: any = localStorage.getItem("cartId");
    deleteCartDetailItem({
      payload: {
        cartId: localStorage.getItem("cartId"),
      },
    });
    setCartPayload(payload);
  };

  useEffect(() => {
    if (deleteCartDetailItemResponse.isSuccess) {
      if (addToCartResponse.isSuccess) {
        if (
          localStorage.getItem("cartId") != "null" &&
          localStorage.getItem("cartId") != null
        ) {
          findByCartId({
            id: localStorage.getItem("cartId"),
          });
        }
      }
      if (finbByCartIdResponse.isSuccess) {
        dispatch(setCart(finbByCartIdResponse.data));
        setCartModel(false);
      }
      auditLog({
        payload: {
          cartId: cartId,
          endTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
          eventName: "WEB",
          request: JSON.stringify(cartPayload),
          response: JSON.stringify(deleteCartDetailItemResponse),
          serviceName: "DELETE_CART_START",
          startTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
          url: "/api/cartDetail/delete",
        },
      });
    }

    if (deleteCartDetailItemResponse.isError) {
      auditLog({
        payload: {
          cartId: cartId,
          endTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
          eventName: "WEB",
          request: JSON.stringify(cartPayload),
          response: JSON.stringify(deleteCartDetailItemResponse),
          serviceName: "DELETE_CART",
          startTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
          url: "/api/cartDetail/delete",
        },
      });
    }
  }, [
    deleteCartDetailItemResponse.isSuccess,
    deleteCartDetailItemResponse.isError,
  ]);

  const toggleFavourites = () => {
    let payload = {
      parkingLocationId: bookingData?.bookingDetail.id,
      customerId: customerId,
      status: true,
    };
    saveCustomerFavourite({ token: token, payload: payload });
  };

  useEffect(() => {
    if (favouriteData) {
      setFavourite(favouriteData);
    }
  }, [favouriteData]);

  useEffect(() => {
    if (bookingData?.bookingDetail) {
      let tamp: any = [];
      bookingData?.bookingDetail &&
        bookingData?.bookingDetail?.imageList &&
        bookingData?.bookingDetail.imageList.map((image: any) =>
          tamp.push({ src: image?.filePreSignedUrl })
        );
      setImageData(tamp);
    }
  }, [bookingData?.bookingDetail]);

  useEffect(() => {
    const selectedTimeZone = timezones.filter(
      (item) => item.value === Intl.DateTimeFormat().resolvedOptions().timeZone
    );

    setSelectedTZOptions(selectedTimeZone);
  }, []);

  useEffect(() => {
    if (favouriteResponse.isSuccess) {
      dispatch(setFavouriteDetail(favouriteResponse.data));
      getAllParkingSpaceLoByLatAndLang({
        payload: {
          offset: 5,
          page: 0,
          lat: getLatLng?.lat,
          lng: getLatLng?.lng,
          customerId: getlogedIn ? customerId : 0,
          orderBy: "asc",
          columnName: "id",
        },
      });
      findParkingSpaceLocationById({
        id: bookingData?.selectedParking.id,
        customerId: getlogedIn ? customerId : 0,
        token: token,
      });
      setStatusCode({
        type: "success",
        code: "Favourite parking updated successfully.",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
    if (favouriteResponse.isError) {
      let errorData: any = billingRateResponse.error;
      let error = errorData.error || errorData.data.serviceErrors[0].msg;
      setStatusCode({
        type: "error",
        code: "ERROR_ON_ADDING_PARKING_TO_FAVOURITE",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [favouriteResponse.isSuccess, favouriteResponse.isError]);


  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  const styleActiveModel = {
    position: "absolute" as "absolute",
    top: "52%",
    left: "47%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    p: "40px",
    px: "40px",
  };

  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState(false) as any;

  const [editIndex, setEditIndex] = useState<number | null>(null);

  const handleCloseModal = () => {
    setEditIndex(null);
    setOpen(false);
  };

  const onGuestChange = (adults: number, kids: number) => {
    setAdults(adults)
    setKids(kids)
    const guest = {
      adults: adults,
      kids: kids ? kids : 0
    }
    setPassengerDetails(guest);
  }

  useEffect(() => {
  }, [passengerDetails])

  // useEffect(() => {
  //   if (storedPassengerDetail && Object.keys(storedPassengerDetail).length > 0) {
  //     setPassengerDetails(storedPassengerDetail?.passengerDetails);
  //   }
  // }, []);



  return (
    <div>
      <>
        {isAlertVisible && (
          <div className="w-full lg:flex block lg:flex-wrap justify-center ">
            <MuiAlert
              severity={statusCode?.type!}
              messageType={statusCode?.code!}
            />
          </div>
        )}
        <CustomizedSteppers activeStep={1} />
        <p className="lg:text-[30px] mt-4 md:text-[25px] text-[20px] text-gray-600 ml-6 text-start font-semibold underline">
          Review Booking
        </p>
        <div className=" w-full text-gray-600 px-7 py-4 mb-4">
          <div className="">
            <p className="mt-3 lg:text-[22px] md:text-[18px] text-[14px] font-semibold">
              {fromCity ? fromCity : bookingData?.bookingDetail?.address} {toCity && (`→`)} {toCity}
            </p>
            <p className="mt-3  flex lg:flex-row md:flex-row flex-col gap-6">
              <p><span className="font-semibold md:text-md text-sm">Pickup | </span>{formatIndianDateTime(bookingData?.checkIn)}</p>
              {(bookingData?.tripType?.typeName === 'OutStation Round Trip' || bookingData?.tripType?.typeName === 'Hourly Rental') &&
                <p> <span className="font-semibold md:text-md text-sm">Drop | </span>{formatIndianDateTime(bookingData?.checkOut)}</p>}
            </p>
          </div>
        </div>
        <div className="mx-[2%] mt-[-20px] flex lg:flex-row  flex-col  gap-4">
          <div className="flex flex-col lg:w-[60%]  w-full gap-4">
            <div className="bg-[#F9F4EF]  p-4 shadow  rounded-xl">
              <div className="flex flex-col md:justify-center justify-start md:items-center items-start sm:flex-row">
                <div
                  className="w-full sm:w-[300px] h-[200px] rounded-lg sm:mr-4 relative flex-shrink-0"
                  style={{
                    backgroundImage: `url(${bookingData?.bookingDetail?.imageList &&
                      bookingData?.bookingDetail?.imageList[0]?.filePreSignedUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                </div>
                <div className="flex-1 items-start justify-center flex flex-col md:p-4 p-2">
                  <div className="flex items-center justify-between">
                    <h3 className="font-bold lg:text-[40px] md:text-[35px] text-[25px] text-[#ED1C24]">
                      {bookingData?.bookingDetail?.vehicleDetailObj?.model}

                    </h3>
                    <Stack spacing={1}>
                      <Rating
                        name="vehicle-rating"
                        value={bookingData?.bookingDetail?.parkingSpaceRating?.toFixed(1) || 1}
                        precision={0.5}
                        readOnly
                        size="small"
                        sx={{ color: "#ED1C24" }}
                      />
                    </Stack>
                  </div>
                  <h3 className="lg:text-[25px] md:text-[20px] text-[15px] text-[#ED1C24]">
                    {bookingData?.selectedParking?.parentCompanyName}
                  </h3>
                  <div className="text-gray-800 mt-2 px-2 md:px-0">
                    <ul className="list-disc space-x-2 flex flex-wrap ml-4 md:ml-6 lg:ml-6 gap-4" style={{ color: '#ED1C24' }}>
                      <li><span className="text-gray-800 lg:text-md text-sm text-[16px]">{bookingData?.bookingDetail?.vehicleDetailObj?.typeDisplayValue}</span></li>
                      <li><span className="text-gray-800 lg:text-md text-sm text-[16px]">{bookingData?.bookingDetail.vehicleDetailObj?.isAc ? "AC" : "Non AC"}</span></li>
                      <li><span className="text-gray-800 lg:text-md text-sm text-[16px]">{bookingData?.bookingDetail?.vehicleDetailObj?.seatingCapacity} Seats</span></li>
                    </ul>
                    <ul className="list-disc space-x-2 flex flex-wrap ml-4 md:ml-6 lg:ml-6 gap-4" style={{ color: '#ED1C24' }}>
                      {(billingDetail?.distance || parkingData?.distanceInKm) && (
                        <li><span className="text-gray-800 lg:text-md text-sm text-[16px]">{Math.ceil(
                          bookingData?.tripType?.typeName === "OutStation Round Trip"
                            ? ((billingDetail?.distance ?? parkingData?.distanceInKm) || 0) * 2
                            : (billingDetail?.distance ?? parkingData?.distanceInKm) || 0
                        )} kms included</span></li>
                      )}
                    </ul>
                  </div>
                  {/**  <p className="font-poppins font-semibold lg:text-[28px] md:text-[20px] text-[16px] text-gray-600">Compact Car</p> */}
                </div>
              </div>
              <div className="mt-2">
                <div className="flex md:flex-row md:justify-around justify-start md:flex-wrap gap-2 flex-col text-gray-600 mt-2">
                  {(billingDetail?.distance || parkingData?.distanceInKm) && (
                    <><div className="flex items-center gap-2">
                      <img src={ExtrakmFare} alt="Amenities" className="md:w-10 w-6 md:h-10 h-6" />
                      <div>
                        <p className="font-bold text-gray-600">Extra km fare</p>
                        <p className="text-gray-700 text-sm">
                          ₹{parkingData?.selectedParkingCategoryRes?.commExtraRate}/km after {Math.ceil(
                            (bookingData?.tripType?.typeName === "OutStation Round Trip"
                              ? ((billingDetail?.distance ?? parkingData?.distanceInKm) || 0) * 2
                              : (billingDetail?.distance ?? parkingData?.distanceInKm) || 0)
                          )} kms
                        </p>
                      </div>
                    </div>
                    </>
                  )}
                  <div className="flex items-center gap-2">
                    <img src={FuelType} alt="Amenities" className="md:w-10 w-6 md:h-10 h-6" />
                    <div>
                      <p className="font-bold md:text-lg text-md text-gray-600">Fuel Type</p>
                      <p className="text-gray-700 md:text-sm text-xs ">{parkingData?.vehicleDetailObj?.fuelType} with {parkingData?.vehicleDetailObj?.gearType} Gear</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <img src={Cancellation} alt="Amenities" className="md:w-10 w-6 md:h-10 h-6" />
                    <div>
                      <p className="font-bold  md:text-lg text-md text-gray-600">Cancellation</p>
                      <p className="text-gray-700 md:text-sm text-xs">Free till {parkingData?.selectedParkingCategoryRes?.cancellationDueTime} hour of departure</p>
                    </div>
                  </div>
                  {/* <div className="flex items-center gap-2">
                    <MdOutlineRoomService size={30} className="text-gray-500" />
                    <div>
                      <p className="font-bold text-gray-600">Amenities</p>
                      {ammenitiesList?.map((item: any, index) => (
                        <p key={index} className="text-gray-700 text-sm">
                          {item?.displayValue}
                        </p>
                      ))}
                    </div>
                  </div> */}

                </div>
              </div>
            </div>
            {/** Inclusions & Exclusions */}
            <div className="bg-[#ED1C24]  p-6 shadow  flex md:flex-row flex-col gap-4 rounded-xl mb-2">
              <div className="inclusions md:w-[43%] w-full gap-6 flex md:flex-col flex-row items-center pr-4 mb-4 sm:mb-0 sm:pr-4">
                <h3 className="font-semibold text-[16px] bg-white px-4 py-1 rounded-full">Inclusions</h3>
                <div className="text-white text-sm md:text-base mt-2">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: bookingData?.bookingDetail?.inclusions || "No inclusions available.",
                    }}
                  />
                </div>
              </div>
              <div className="md:flex hidden border-l-2 items-center h-48 w-[4%] border-dotted "></div>
              <div className="exclusions gap-6 flex md:flex-col flex-row md:w-[43%] w-full  pr-4 items-center mb-4 sm:mb-0 sm:pr-4">
                <h3 className="font-semibold text-center text-[16px] bg-white px-4 py-1 rounded-full">Exclusions</h3>
                <div className="text-white text-sm md:text-base">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: bookingData?.bookingDetail?.exclusions || "No exclusions available.",
                    }}
                  />
                  {bookingData?.tripType?.typeName === "Airport Drop" && (
                    <div>The Airport entry charge, if applicable, is not included in the fare and will be charged extra.</div>
                  )}
                </div>
              </div>
            </div>

            <div className="bg-[#F9F4EF]  p-4 rounded-xl ">
              <h2 className="text-xl md:text-2xl font-bold mb-4 text-gray-600">Read before you book!</h2>
              <div className="my-2">
                <h3 className="text-lg md:text-xl font-medium text-gray-600">Special Instructions</h3>
                <div className="text-gray-600 text-sm md:text-base mt-2">
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        bookingData?.bookingDetail?.specialInstructions || "No instruction available.",
                    }}
                  />
                </div>
              </div>
              <div className="my-2">
                <h3 className="text-lg md:text-xl font-medium text-gray-600">Cancellation Policy</h3>
                <div className="text-gray-600 text-sm md:text-base mt-2">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: bookingData?.bookingDetail?.cancellationPolicy || "No cancellation available.",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:w-[40%]  w-full relative">
            <div className="bg-[#F9F4EF]  p-4 shadow-md rounded-xl ">
              <Formik
                enableReinitialize
                initialValues={{
                  pickupAddress: fromLocationData?.sublocality
                    ? fromLocationData.formatted_address
                    : '',
                  dropOffAddress: toLocationData?.sublocality
                    ? toLocationData.formatted_address
                    : '',
                  //fullName: "",
                  //gender: "Male",
                  emailId: storedEmail ? storedEmail : storedPassengerDetail?.emailId,
                  contactNumber: storedContactNumber ? storedContactNumber : storedPassengerDetail?.contactNumber,
                  passengerDetails,
                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ setFieldValue, values, handleSubmit, touch, error, validateField, errors, touched }: any) => (
                  <Form>
                    <div className="text-gray-600 tracking-wide text-center font-semibold lg:text-[28px] md:text-[24px] text-[20px]">Trip Details</div>
                    <div className="mt-4">
                      <p className="font-semibold text-left text-gray-600 text-md mb-1 ml-2">Pick-up Address</p>
                      <div className="bg-gray-200 border border-gray-300 rounded-full py-1 px-3 flex flex-row items-center w-full">
                        <div className="flex flex-row w-full">
                          <img src={LocationIcon} alt="Location" className="w-3.5 h-3.5 mt-3 mr-2 text-red-500" />
                          <Autocomplete
                            onLoad={(autocomplete: any) => {
                              setAutocompleteFromCity(autocomplete);

                            }}
                            className="w-full"
                            onPlaceChanged={() => {
                              if (!autocompleteFromCity) {
                                console.error("Autocomplete instance is not loaded.");
                                return;
                              }
                              const place = autocompleteFromCity.getPlace();
                              if (!place || !place.geometry) {
                                console.error("Autocomplete place data is incomplete or null.");
                                return;
                              }
                              const locationDetail = {
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng(),
                                formatted_address: place.formatted_address,
                                postalcode: "",
                                country: "",
                                state: "",
                                city: "",
                                locality: "",
                                sublocality: "",
                                route: "",
                                street: "",
                              };
                              place.address_components.forEach((component: any) => {
                                if (component.types.includes("postal_code")) {
                                  locationDetail.postalcode = component.long_name;
                                }
                                if (component.types.includes("country")) {
                                  locationDetail.country = component.long_name;
                                }
                                if (component.types.includes("administrative_area_level_1")) {
                                  locationDetail.state = component.long_name;
                                }
                                if (component.types.includes("administrative_area_level_2")) {
                                  locationDetail.city = component.long_name;
                                }
                                if (component.types.includes("locality")) {
                                  locationDetail.locality = component.long_name;
                                }
                                if (component.types.includes("sublocality")) {
                                  locationDetail.sublocality = component.long_name;
                                }
                                if (component.types.includes("route")) {
                                  locationDetail.route = component.long_name;
                                }
                                if (component.types.includes("street_number")) {
                                  locationDetail.street = component.long_name;
                                }
                              });
                              dispatch(setFromLocation(locationDetail));
                              setFieldValue("pickupAddress", locationDetail.formatted_address);
                              setSearchCity(locationDetail.locality);
                              handleCalculateBilling(
                                place?.formatted_address,
                                toLocationData?.formatted_address,
                                place?.geometry.location.lat(),
                                place?.geometry.location.lng(),
                                toLocationData?.lat,
                                toLocationData?.lng
                              );
                            }}
                          >
                            <div
                              className={`w-full mt-2 items-center justify-between flex ${touch?.pickupAddress && error?.pickupAddress ? "border-red-500" : "border-gray-300"
                                }`}
                            >
                              <input
                                type="text"
                                id="pickupAddress"
                                onChange={(e) => {
                                  setInputFromAddress(e.target.value);
                                }}
                                ref={placesSearchRefPickUp}
                                placeholder="Enter pick-up address to know the exact fare & avoid extra charges after the trip"
                                value={values.pickupAddress ? values.pickupAddress : inputFromAddress?.formatted_address}
                                className="w-full bg-transparent focus:outline-none text-black placeholder-gray-500"
                              />
                              <img src={clearIcon}
                                onClick={() => clearSearchResults('pickup', setFieldValue)}
                                className="cursor-pointer w-3.5 h-3.5" />
                            </div>
                          </Autocomplete>
                        </div>


                      </div>
                      <ErrorMessage
                        name="pickupAddress"
                        component="div"
                        className="text-red-500 text-sm mt-1 ml-4"
                      />
                    </div>

                    {(bookingData?.tripType?.typeName !== 'Hourly Rental' && bookingData?.tripType?.typeName !== 'OutStation Round Trip') && (
                      <div className="mt-4">

                        <p className="font-semibold text-left text-gray-600 text-md mb-1 ml-2">Drop-off Address</p>
                        <div className="bg-gray-200 border border-gray-300 rounded-full py-1 px-3 flex flex-row items-center w-full">
                          <div className="flex flex-row w-full">
                            <img src={LocationIcon} alt="Location" className="w-3.5 h-3.5 mt-3 mr-2 text-red-500" />
                            <Autocomplete
                              onLoad={(autocomplete) => {
                                setAutocompleteToCity(autocomplete);
                              }}
                              options={{
                                types: bookingData?.tripType?.typeName === "Airport Drop" ? ["airport"] : [],
                              }}
                              className="w-full"
                              onPlaceChanged={() => {
                                if (!autocompleteToCity) {
                                  console.error("Autocomplete instance is not loaded.");
                                  return;
                                }

                                const place = autocompleteToCity.getPlace();

                                if (!place || !place.geometry) {
                                  console.error("Autocomplete place data is incomplete.");
                                  return;
                                }

                                const locationDetail = {
                                  lat: place.geometry.location.lat(),
                                  lng: place.geometry.location.lng(),
                                  formatted_address: place.formatted_address,
                                  postalcode: "",
                                  country: "",
                                  state: "",
                                  city: "",
                                  locality: "",
                                  sublocality: "",
                                  route: "",
                                  street: "",
                                };


                                place.address_components.forEach((component: any) => {
                                  if (component.types.includes("postal_code")) {
                                    locationDetail.postalcode = component.long_name;
                                  }
                                  if (component.types.includes("country")) {
                                    locationDetail.country = component.long_name;
                                  }
                                  if (component.types.includes("administrative_area_level_1")) {
                                    locationDetail.state = component.long_name;
                                  }
                                  if (component.types.includes("administrative_area_level_2")) {
                                    locationDetail.city = component.long_name;
                                  }
                                  if (component.types.includes("locality")) {
                                    locationDetail.locality = component.long_name;
                                  }
                                  if (component.types.includes("sublocality")) {
                                    locationDetail.sublocality = component.long_name;
                                  }
                                  if (component.types.includes("route")) {
                                    locationDetail.route = component.long_name;
                                  }
                                  if (component.types.includes("street_number")) {
                                    locationDetail.street = component.long_name;
                                  }
                                });

                                setFieldValue("dropOffAddress", locationDetail.formatted_address);
                                dispatch(setToLocation(locationDetail));
                              }}
                            >
                              <div
                                className={`w-full mt-2 items-center justify-between flex ${touch?.dropOffAddress && error?.dropOffAddress ? "border-red-500" : "border-gray-300"
                                  }`}
                              >
                                <input
                                  type="text"
                                  id="dropOffAddress"
                                  onChange={(e) => {
                                    setInputToAddress(e.target.value);
                                  }}
                                  ref={placesSearchRefDropOff}
                                  placeholder="Enter drop-off address to know the exact fare & avoid extra charges after the trip"
                                  value={values.dropOffAddress ? values.dropOffAddress : inputToAddress?.formatted_address}
                                  className="w-full bg-transparent focus:outline-none text-black placeholder-gray-500"
                                />
                                <img src={clearIcon}
                                  onClick={() => clearSearchResults('dropoff', setFieldValue)}
                                  className="cursor-pointer w-3.5 h-3.5" />
                              </div>
                            </Autocomplete>
                          </div>

                        </div>
                        <ErrorMessage
                          name="dropOffAddress"
                          component="div"
                          className="text-red-500 text-sm mt-1 ml-4"
                        />
                      </div>
                    )}

                    <div className="mt-4 text-black font-bold text-lg">
                      <div className="">
                        <div className="text-gray-600 tracking-wide text-center font-semibold lg:text-[28px] md:text-[24px] text-[18px]">Traveller Details</div>

                        {/* <Button onClick={() => setOpen(true)} startIcon={<Plus />} variant="text">
                          Add Passenger
                        </Button> */}
                      </div>
                    </div>
                    <div className="mt-4 flex  flex-col ">
                      <Field name="emailId">
                        {({ field, meta }: any) => (
                          <div>
                            <TextField
                              {...field}
                              // label="Email ID"
                              placeholder="Enter Email ID"
                              fullWidth
                              margin="normal"
                              error={!!meta.touched && !!meta.error}
                              onChange={(e) => {
                                setStoredEmail(e.target.value);
                                setFieldValue("emailId", e.target.value);
                              }}
                              className="bg-gray-200 border border-gray-300 rounded-full  w-full"

                              InputProps={{
                                disableUnderline: true,
                                sx: {
                                  border: 'none',
                                  '&.MuiOutlinedInput-root': {
                                    '& fieldset': {
                                      border: 'none',
                                    },
                                  },
                                },
                              }}
                            />
                            {meta.touched && meta.error && (
                              <Typography variant="body2" className="text-red-500 text-center">
                                {meta.error}
                              </Typography>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="contactNumber">
                        {({ field, meta }: any) => (
                          <div>
                            <TextField
                              {...field}
                              placeholder="Enter 10 digit mobile number"
                              fullWidth
                              className="bg-gray-200 border border-gray-300 rounded-full  w-full"
                              margin="normal"
                              error={!!meta.touched && !!meta.error}
                              onChange={(e) => {
                                setStoredContactNumber(e.target.value);
                                setFieldValue("contactNumber", e.target.value);
                              }}
                              InputProps={{
                                startAdornment: (
                                  <Typography variant="body1" style={{ marginRight: "0.5rem" }}>
                                    +91
                                  </Typography>
                                ),
                                disableUnderline: true,
                                sx: {
                                  border: 'none',
                                  '&.MuiOutlinedInput-root': {
                                    '& fieldset': {
                                      border: 'none',
                                    },
                                  },
                                },
                              }}
                            />
                            {meta.touched && meta.error && (
                              <Typography variant="body2" className="text-red-500  text-center">
                                {meta.error}
                              </Typography>
                            )}
                          </div>

                        )}
                      </Field>
                      <div className="flex justify-center">
                        <GuestCounter
                          onGuestChange={onGuestChange}
                          initialAdults={storedPassengerDetail ? passengerDetails?.storedPassengerDetail?.adults : adults}
                          initialKids={storedPassengerDetail ? passengerDetails?.storedPassengerDetail?.kids : kids}
                          storedPassengerDetail={storedPassengerDetail}
                        />
                      </div>
                      {touched.adults && errors.adults && (
                        <p className="text-red-500 text-sm mt-1">{errors.adults}</p>
                      )}
                    </div>

                    {(billingDetail?.totalAmount || parkingData?.totalAmount) && (
                      <>
                        <div className="flex flex-col items-start py-6">
                          {/* Grand Total */}
                          <span className="text-lg font-semibold text-gray-600">Grand Total:
                            ₹{billingDetail?.totalAmount
                              ? (billingDetail?.totalAmount + (billingDetail?.totalTaxAmount || 0) + (billingDetail?.convenienceFee || 0)).toFixed(2)
                              : (parkingData?.calculateBillingRateRespDTO?.totalAmount + (parkingData?.calculateBillingRateRespDTO?.totalTaxAmount || 0) + (parkingData?.calculateBillingRateRespDTO?.convenienceFee || 0)).toFixed(2)}</span>

                          {/* View Breakup Toggle */}
                          <div
                            className="text-gray-600  text-sm flex items-center space-x-2 cursor-pointer"
                            onClick={() => setIsOpen(!isOpen)}
                          >
                            {isOpen ? (
                              <>
                                <span>Hide Breakup</span>
                                <ChevronUp size={16} className="bg-[#ED1C24] rounded-full text-white" />
                              </>
                            ) : (
                              <>
                                <span>View Breakup</span>
                                <ChevronDown size={16} className="bg-[#ED1C24] rounded-full text-white" />
                              </>
                            )}
                          </div>
                        </div>

                        {/* Breakup Details */}
                        {isOpen && (
                          <div className="mt-4">
                            {/* Vehicle Charges */}
                            <div className="flex justify-between py-1">
                              <span className="text-lg font-medium">Vehicle Charges:</span>
                              <span className="text-lg font-medium">₹{billingDetail?.totalAmount
                                ? (billingDetail.totalAmount - (billingDetail.tollCharges || 0)).toFixed(2)
                                : (parkingData?.calculateBillingRateRespDTO?.totalAmount - (parkingData?.calculateBillingRateRespDTO?.tollCharges || 0)).toFixed(2)}</span>
                            </div>

                            {/* Taxes Section */}
                            <div className="flex flex-col justify-between">
                              <div
                                className="flex justify-between py-1 cursor-pointer"
                                onClick={() => setTaxOpen(!taxOpen)}
                              >
                                <p className="text-base flex items-center text-start">
                                  Taxes
                                  {taxOpen ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
                                </p>
                                <p className="text-base text-start">
                                  ₹{billingDetail?.totalTaxAmount ? (billingDetail?.totalTaxAmount.toFixed(2)) : (parkingData?.calculateBillingRateRespDTO?.totalTaxAmount.toFixed(2))}
                                </p>
                              </div>

                              {taxOpen && (
                                <div className="pl-4">
                                  {((parkingData?.calculateBillingRateRespDTO?.salesTaxAmount > 0) || (billingDetail?.salesTaxAmount > 0)) && (
                                    <div className="flex justify-between py-1">
                                      <p className="text-base text-start">CGST</p>
                                      <p className="text-base text-start">
                                        ₹{billingDetail?.salesTaxAmount
                                          ? billingDetail.salesTaxAmount.toFixed(2)
                                          : parkingData?.calculateBillingRateRespDTO?.salesTaxAmount.toFixed(2)}
                                      </p>
                                    </div>
                                  )}
                                  {((parkingData?.calculateBillingRateRespDTO?.stateTaxAmount > 0) || (billingDetail?.stateTaxAmount > 0)) && (
                                    <div className="flex justify-between py-1">
                                      <p className="text-base text-start">SGST</p>
                                      <p className="text-base text-start">
                                        ₹{billingDetail?.stateTaxAmount
                                          ? billingDetail.stateTaxAmount.toFixed(2)
                                          : parkingData?.calculateBillingRateRespDTO?.stateTaxAmount.toFixed(2)}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>

                            {/* Fixed Fee */}
                            {((parkingData?.calculateBillingRateRespDTO?.fixedFee > 0) || (billingDetail?.fixedFee > 0)) && (
                              <div className="flex justify-between py-1">
                                <p className="text-base text-start">Fixed Fee</p>
                                <p className="text-base ml-5 text-start">₹{billingDetail?.fixedFee
                                  ? billingDetail.fixedFee.toFixed(2)
                                  : parkingData?.calculateBillingRateRespDTO?.fixedFee.toFixed(2)}</p>
                              </div>
                            )}

                            {/* Convenience Fee */}
                            <div className="flex justify-between py-1">
                              <p className="text-base text-start">Convenience Fee</p>
                              <p className="text-base ml-5 text-start">
                                ₹
                                {billingDetail?.convenienceFee !== undefined && billingDetail?.convenienceFee !== null
                                  ? billingDetail.convenienceFee.toFixed(2)
                                  : parkingData?.calculateBillingRateRespDTO?.convenienceFee?.toFixed(2)}
                              </p>
                            </div>

                            {/* Toll Charges */}
                            <div className="flex justify-between py-1">
                              <span className="text-lg font-medium">Toll Charges:</span>
                              <span className="text-lg font-medium">
                                ₹{billingDetail?.tollCharges != null
                                  ? billingDetail.tollCharges.toFixed(2)
                                  : parkingData?.calculateBillingRateRespDTO?.tollCharges != null
                                    ? parkingData.calculateBillingRateRespDTO.tollCharges.toFixed(2)
                                    : "0.00"}
                              </span>
                            </div>
                          </div>
                        )}
                      </>)}

                    <FormControlLabel
                      className=""
                      control={<Checkbox name="terms" />}
                      label="Use pickup location as billing address"
                    />
                    <Typography variant="caption" display="block" gutterBottom>
                      By proceeding to book, I Agree to Car Rental's{" "}
                      <a
                        href="https://carrental.rightbraininfotech.in/profile/privacy-policy"
                        style={{ color: "blue", textDecoration: "underline" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </a>
                      ,{" "}
                      and{" "}
                      <a
                        href="https://carrental.rightbraininfotech.in/profile/terms-and-condition"
                        style={{ color: "blue", textDecoration: "underline" }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Terms of Service
                      </a>
                      .
                    </Typography>
                    <div className="flex flex-col sm:flex-row items-center gap-5 mt-2">
                      <button
                        type="submit"
                        onClick={handleSubmit}
                        className={`${dateRange(
                          blackOutDay,
                          bookingData?.checkIn,
                          bookingData?.checkOut,
                        ) || addToCartResponse.isLoading
                          ? "bg-gray-300 hover:bg-gray-300 text-black text-sm cursor-not-allowed"
                          : "bg-[#ED1C24] hover:bg-red-600 text-white"
                          } w-full py-1.5 rounded-full text-lg font-semibold shadow-lg transition-all whitespace-nowrap`}
                        disabled={
                          dateRange(
                            blackOutDay,
                            bookingData?.checkIn,
                            bookingData?.checkOut,
                          ) || addToCartResponse.isLoading
                        }
                      >{
                          dateRange(
                            blackOutDay,
                            bookingData?.checkIn,
                            bookingData?.checkOut,
                          )
                            ? "vehicle not available"
                            : billingDetail?.totalAmount || parkingData?.calculateBillingRateRespDTO?.totalAmount
                              ? `Pay 
                              ₹ ${billingDetail?.totalAmount
                                ? (billingDetail?.totalAmount + (billingDetail?.totalTaxAmount || 0) + (billingDetail?.convenienceFee || 0)).toFixed(2)
                                : (parkingData?.calculateBillingRateRespDTO?.totalAmount + (parkingData?.calculateBillingRateRespDTO?.totalTaxAmount || 0) + (parkingData?.calculateBillingRateRespDTO?.convenienceFee || 0)).toFixed(2)
                              }`
                              : "Pay"
                        }</button>
                      {/* <RegularButton
                        onClick={() => {
                          handleSubmit();
                        }}
                        className="w-full"
                        disabled={
                          dateRange(
                            blackOutDay,
                            bookingData?.checkIn,
                            bookingData?.checkOut,
                          ) || addToCartResponse.isLoading
                        }
                        title={
                          dateRange(
                            blackOutDay,
                            bookingData?.checkIn,
                            bookingData?.checkOut,
                          )
                            ? "Parking not available"
                            : billingDetail?.totalAmount || parkingData?.calculateBillingRateRespDTO?.totalAmount
                              ? `Pay ₹ ${billingDetail?.totalAmount
                                ? (billingDetail?.totalAmount + (billingDetail?.totalTaxAmount || 0)).toFixed(2)
                                : (parkingData?.calculateBillingRateRespDTO?.totalAmount + (parkingData?.calculateBillingRateRespDTO?.totalTaxAmount || 0)).toFixed(2)
                              }`
                              : "Pay"
                        }

                      /> */}
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </>
      {/* <div className="mt-5">
        <Footer />
      </div> */}
      {enumResponse.isLoading ||
        billingRateResponse.isLoading ||
        addToCartResponse.isLoading ||
        userIdResponse.isLoading ||
        finbByCartIdResponse.isLoading ||
        deleteCartDetailItemResponse.isLoading ||
        favouriteResponse.isLoading ? (
        <Loading />
      ) : null}
    </div>
  );
};

export default BookingDetail;
